<app-callcard-info-card *ngIf="card" [callcard]="card"></app-callcard-info-card>
<app-callcard-clocations-card *ngIf="card" [callcard]="card"></app-callcard-clocations-card>
<app-callcard-cevents-card *ngIf="card" [callcard]="card"></app-callcard-cevents-card>
